import { useEffect, useState, useRef } from "react";
import { Button, TextField, FormControl, InputLabel, Select, MenuItem, Checkbox, ListItemText, OutlinedInput, ListSubheader, Switch, FormControlLabel, Box, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Alert} from "@mui/material";
import { CloudUpload as CloudUploadIcon, AttachFile as AttachFileIcon } from "@mui/icons-material";
import "../Tabs/tabsTable.css";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from "react-redux";
import { registerUserSessionData,getUserDetailsForTrainingAndSession, updateUserRegistration} from "../../redux/actions";
import { bulkNominateUsers, getEmployeeDropdownData } from "../../http/requests/session";
import { Link } from "react-router-dom";
import Loader from "../Loaders/Loader";
import moment from "moment";
import { Modules } from "../../common/constants/sidebar";
import * as XLSX from 'xlsx';


// const MenuProps = {
//   PaperProps: {
//     style: {
//       maxHeight: "30rem",
//       width: "10rem",
//     },
//   },
// };

const ViewAndNominate = (props) => {
  const [selectAll, setSelectAll] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const { allUserDetails, userData } = useSelector(({ USER }) => USER);
  const { listItems,userDetailsForTrainingAndSession,reportees } = useSelector(({ MODULES }) => MODULES);
  const [userMembers, setUserMembers] = useState(null);
  const [userMembersForAdmin,setUserMembersForAdmin] = useState(allUserDetails);
  const [isRegistered,setIsRegistered] = useState(false);
  const [selectedUserIds, setSelectedUserIds] = useState("");
  const [reason,setReason] = useState('');
  const [openReasonTextbox,setOpenReasonTextbox] = useState(false);
  const { vTrackLoader } = useSelector(({ APP_STATE }) => APP_STATE);
  
  // New states for auto-approval feature
  const [autoApprove, setAutoApprove] = useState(false);
  
  // New states for bulk upload feature
  const [selectedFile, setSelectedFile] = useState(null);
  const [bulkUploadOpen, setBulkUploadOpen] = useState(false);
  const [uploadResults, setUploadResults] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const fileInputRef = useRef(null);

  // New state for employee dropdown data
  const [employeeDropdownData, setEmployeeDropdownData] = useState([]);
  const [filteredEmployees, setFilteredEmployees] = useState([]);

  const [userSkills, setUserSkills] = useState(
    listItems ? listItems.Skills : []
  );

  const dispatch = useDispatch();

  // Fetch employee dropdown data on component mount
  useEffect(() => {
    const fetchEmployeeData = async () => {
      try {
        console.log('Attempting to fetch employee dropdown data...');
        const response = await getEmployeeDropdownData();
        console.log('Employee dropdown data response:', response);
        setEmployeeDropdownData(response);
        setFilteredEmployees(response);
      } catch (error) {
        console.error('Error fetching employee dropdown data:', error);
        console.error('Error details:', error?.response?.data || error.message);
        
        // Fallback: Use existing user data structure for now
        console.log('Falling back to existing user data structure...');
        
        if (userData.data.roleName === "Admin" && allUserDetails?.data) {
          // Transform allUserDetails to match the expected structure
          const transformedData = allUserDetails.data.map(user => ({
            azureId: user.id, // Using existing id as azureId for now
            name: user.firstName && user.lastName ? `${user.firstName} ${user.lastName}` : user.firstName || user.email,
            employeeId: user.employeeId || user.email, // Use employeeId if available, fallback to email
            email: user.email // Add email field
          }));
          console.log('Transformed admin data:', transformedData);
          setEmployeeDropdownData(transformedData);
          setFilteredEmployees(transformedData);
        } else if (userData.data.roleName === "Project Manager" && reportees) {
          // Transform reportees to match the expected structure
          const transformedData = reportees.map(user => ({
            azureId: user.id, // Using existing id as azureId for now
            name: user.firstName && user.lastName ? `${user.firstName} ${user.lastName}` : user.firstName || user.email,
            employeeId: user.employeeId || user.email, // Use employeeId if available, fallback to email
            email: user.email // Add email field
          }));
          console.log('Transformed reportees data:', transformedData);
          setEmployeeDropdownData(transformedData);
          setFilteredEmployees(transformedData);
        } else {
          toast.error('Failed to load employee data');
        }
      }
    };

    fetchEmployeeData();
  }, [allUserDetails, reportees, userData.data.roleName]);

  useEffect(() => {
    if(userData.data.roleName === "Admin"){
      if (allUserDetails && allUserDetails.length) {
        setUserMembersForAdmin(allUserDetails);
      }
    }
  }, [allUserDetails]);

  useEffect(()=>{
    if(userData.data.roleName === "Project Manager"){
      if (reportees && reportees.length) {
        setUserMembers(prevState => ({
          ...prevState,
          data: reportees
        }));
      }
    }
  },[reportees]);

  useEffect(() => {
    if(userDetailsForTrainingAndSession&&userDetailsForTrainingAndSession.sessionID===props.sessionData.sessionId&&(userDetailsForTrainingAndSession.status==="Registered"||userDetailsForTrainingAndSession.status==="Accepted")){
      setIsRegistered(true);
    }else{
      setIsRegistered(false);
    }
  },[userDetailsForTrainingAndSession]);

  const handleReasonChange = (event) => {
    setReason(event.target.value);
  };
  const handleSubmit = () => {
    dispatch(updateUserRegistration({sessionId:props.sessionData.sessionId,reason:reason}));
    setOpenReasonTextbox(false);
    setSelectedUsers([]); setSelectedUserIds(""); handleClose();
  };

  const handleCancel = () => {
    setOpenReasonTextbox(false);
  }

  const handleClose = () => {
    props.onResponse(true);
  };

  // File handling functions
  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Validate file type
      const allowedTypes = [
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ];
      
      if (allowedTypes.includes(file.type) || file.name.endsWith('.xlsx') || file.name.endsWith('.xls')) {
        setSelectedFile(file);
      } else {
        toast.error('Please select a valid Excel file (.xlsx or .xls)');
        event.target.value = '';
      }
    }
  };

  // Bulk upload API function
  const handleBulkUpload = async () => {
    if (!selectedFile) {
      toast.error('Please select an Excel file');
      return;
    }

    setIsUploading(true);
    try {
      const formData = new FormData();
      formData.append('file', selectedFile);
      formData.append('autoApprove', autoApprove.toString());
      
      const response = await bulkNominateUsers(props.sessionData.sessionId, formData);
      
      setUploadResults(response);
      toast.success('Bulk upload completed!');
      
      // Refresh the session data
      dispatch(getUserDetailsForTrainingAndSession({sessionId: props.sessionData.sessionId}));
      
    } catch (error) {
      toast.error(error?.data?.errorMessage || 'Upload failed. Please try again.');
      console.error('Bulk upload error:', error);
    } finally {
      setIsUploading(false);
    }
  };

  const handleDownloadSampleTemplate = () => {
    // Create sample data with the specified format
    const sampleData = [
      ['EmpID', 'Name'],
      ['E1005', 'John Doe'],
      ['E1006', 'Jane Smith']
    ];

    // Create a new workbook and worksheet
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(sampleData);
    
    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Employee Data');
    
    // Generate Excel file and download
    XLSX.writeFile(wb, 'bulk_nomination_sample.xlsx');
    
    toast.success('Sample Excel file downloaded successfully');
  };

  const closeBulkUpload = () => {
    setBulkUploadOpen(false);
    setSelectedFile(null);
    setUploadResults(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };
  const handleUserChange = (event) => {
    const {
      target: { value },
    } = event;
    if (value.findIndex((val) => val === "Select All") > -1) {
      if (selectAll) {
        setSelectedUsers([]);
        setSelectedUserIds([]);
      } else {
        // Select all employees from dropdown data
        setSelectedUsers(filteredEmployees);
        let azureIds = filteredEmployees.map((user) => {
          return user.azureId;
        });
        setSelectedUserIds(azureIds.join(","));
      }
      setSelectAll(!selectAll);
    } else {
      setSelectedUsers(value);
      let azureIds = value.map((user) => {
        return user.azureId;
      });
      setSelectedUserIds(azureIds.join(","));
      // Reset filtered employees to full list
      setFilteredEmployees(employeeDropdownData);
    }
  };
  
  const getUsersNames = () => {
    let selectedNames = "";
    if (selectedUsers && selectedUsers.length) {
      for (let i = 0; i < selectedUsers.length; i++) {
        selectedNames += selectedUsers[i].name;
        if (i !== selectedUsers.length - 1) selectedNames += ", ";
      }
    }
    return selectedNames;
  };

  const createTopBarForViewAndNominate = () => {
    return (
      <>
      {vTrackLoader && <Loader/>}
      <div >
        <div>
        <div >
        <FormControl sx={{ s: 1, width: "35rem" }}>
        <InputLabel requred id="demo-multiple-checkbox-label">
          Nominate Employee
        </InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          value={selectedUsers}
          onChange={handleUserChange}
          input={<OutlinedInput label="Nominate Employee"/>}
          renderValue={getUsersNames}
          MenuProps={{ PaperProps: { style: { maxHeight: "20rem", width: "30rem", }, }, }}>
          
          {/* Search field */}
          <ListSubheader className="subheader" >
            <TextField
              placeholder="Search Here..."
              className="subheader-field"
              onKeyDown={(e) => {
                e.stopPropagation();
              }}
              autoFocus={true}
              onChange={(e) => {
                const searchTerm = e.target.value.toLowerCase();
                const filtered = employeeDropdownData.filter(
                  (employee) =>
                    employee.name?.toLowerCase().includes(searchTerm) ||
                    employee.employeeId?.toLowerCase().includes(searchTerm) ||
                    employee.email?.toLowerCase().includes(searchTerm)
                );
                setFilteredEmployees(filtered);
              }}
            />
          </ListSubheader>
          
          <div style={{textAlign:"right",cursor: "pointer",height: "2rem"}}>
            <Link onClick = {() => {setSelectedUsers([]);setSelectedUserIds([]);setSelectAll(false);}} style = {{color: "#1773bc",paddingRight:"1rem"}}>
              Clear Selection
            </Link>
          </div>
          <MenuItem key={`select-all`} value={"Select All"} className = "no-left-margin">
            <Checkbox checked={selectAll} />
            <ListItemText primary = {selectAll? "Select None": "Select All"}/>
          </MenuItem>
          
          {/* Employee list */}
          {filteredEmployees.map((employee) => (
            <MenuItem key={employee.azureId} value={employee} className="no-left-margin">
              <Checkbox checked={selectedUsers.findIndex((person)=> person.azureId === employee.azureId) > -1} />
              <ListItemText primary={`${employee.name} (${employee.employeeId}) - ${employee.email}`}/>
            </MenuItem>
          ))}
          
        </Select>
      </FormControl>
    
  </div>
  </div>
  </div>
      </>
    );
  };

  const getHosts = (renderValues) => {
    let hostList = '';
    for (let i = 0; i < renderValues.length; i++) {
      hostList += renderValues[i].hostName;
      if (i !== renderValues.length - 1) {
        hostList += ', ';
      }
    }
    return hostList;
  }
  
  return (
    <div>
      <div style={{ marginBottom: '1rem',marginTop:"-1rem", fontWeight:'bold', fontSize: '1.8rem', color:'#1773BC', display:'flex', justifyContent:'space-between', alignItems: 'center'}}>
          <label>Session Details </label>
          {(props.sessionData.status==='Published')&&moment().isSameOrBefore(moment(props.sessionData.registrationEndDate),'day')&&moment().isSameOrAfter(moment(props.sessionData.registrationStartDate),'day')&&(userData.data.roleName === "Admin"||userData.data.roleName === "Project Manager")&&(
            <Button
              variant="outlined"
              startIcon={<CloudUploadIcon />}
              onClick={() => setBulkUploadOpen(true)}
              style={{ fontSize: '1.2rem', padding: '8px 16px' }}
            >
              Bulk Upload
            </Button>
          )}
      </div>
      <div>
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          <div style={{ flex: "1", marginBottom: "1rem" }}>
          <div style={{display:"flex",flexWrap:"wrap", flexDirection:"column"}}>
            <label style={{  marginRight:"1rem",fontFamily: "Montserrat", fontSize: "1.5rem",color: "rgb(23, 115, 188)" }}>
              Session Name 
            </label>
            <label style={{ fontFamily: "Montserrat", fontSize: "1.7rem" }}>
              {props.sessionData.sessionName}
            </label>
            </div>
          </div>

          <div style={{ flex: "1", marginBottom: "1rem" }}>
          <div style={{display:"flex",flexWrap:"wrap", flexDirection:"column"}}>
            <label style={{ marginRight:"1rem",fontFamily: "Montserrat", fontSize: "1.5rem" ,color: "rgb(23, 115, 188)"}}>
              Session Hosts 
            </label>
            <label style={{  fontFamily: "Montserrat", fontSize: "1.7rem"}}>
              {getHosts(props.sessionData.hosts)}
            </label>
            </div>
          </div>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap" }}>
          <div style={{ flex: "1", marginBottom: "1rem" }}>
            <div style={{display:"flex",flexWrap:"wrap", flexDirection:"column"}}>
            <label style={{ marginRight:"1rem",fontFamily: "Montserrat", fontSize: "1.5rem" ,color: "rgb(23, 115, 188)"}}>
              Skills Targeted 
            </label>
            <label style={{ fontFamily: "Montserrat", fontSize: "1.7rem" }}>
              {props.sessionData.targetedSkill}
            </label>
            </div>
          </div>
          <div style={{ flex: "1", marginBottom: "1rem" }}>
            <div style={{display:"flex",flexWrap:"wrap", flexDirection:"column"}}>
            <label style={{  marginRight:"1rem",fontFamily: "Montserrat", fontSize: "1.5rem",color: "rgb(23, 115, 188)"}}>
              Session Date 
            </label>
            
            <label style={{  fontFamily: "Montserrat", fontSize: "1.7rem"}}>
              {props.sessionData.sessionDate}
            </label>
            </div>
          </div>
        </div>
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          <div style={{ flex: "1", marginBottom: "1rem" }}>
          <div style={{display:"flex",flexWrap:"wrap", flexDirection:"column"}}>
            <label style={{ marginRight:"1rem",fontFamily: "Montserrat", fontSize: "1.5rem",color: "rgb(23, 115, 188)" }}>
              Registration Start Date
            </label>
            <label style={{  fontFamily: "Montserrat", fontSize: "1.7rem" }}>
              {props.sessionData.registrationStartDate}
            </label>
            </div>
          </div>
          <div style={{ flex: "1", marginBottom: "1rem" }}>
            <div style={{display:"flex",flexWrap:"wrap", flexDirection:"column"}}>
            <label style={{ marginRight:"1rem",fontFamily: "Montserrat", fontSize: "1.5rem",color: "rgb(23, 115, 188)"}}>
              Registration End Date 
            </label>
            
            <label style={{ fontFamily: "Montserrat", fontSize: "1.7rem" }}>
              {props.sessionData.registrationEndDate}
            </label>
            </div>
          </div>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap" }}>
        {userDetailsForTrainingAndSession&&userDetailsForTrainingAndSession.registationType==="Nominated"&&(<div style={{ flex: "1", marginBottom: "1rem" }}>
          <div style={{display:"flex",flexWrap:"wrap", flexDirection:"column"}}>
            <label style={{  marginRight:"1rem",fontFamily: "Montserrat", fontSize: "1.5rem",color: "rgb(23, 115, 188)" }}>
              You have been Nominated by 
            </label>
            <label style={{  fontFamily: "Montserrat", fontSize: "1.7rem" }}>
              {userDetailsForTrainingAndSession.nominationManagerID}
            </label>
            </div>
          </div>)}
          {userDetailsForTrainingAndSession&&userDetailsForTrainingAndSession.status&&(<div style={{ flex: "1", marginBottom: "1rem" }}>
          <div style={{display:"flex",flexWrap:"wrap", flexDirection:"column"}}>
            <label style={{  marginRight:"1rem",fontFamily: "Montserrat", fontSize: "1.5rem" ,color: "rgb(23, 115, 188)"}}>
              Status 
            </label>
            <label style={{  fontFamily: "Montserrat", fontSize: "1.7rem" }}>
              {userDetailsForTrainingAndSession.status}
            </label>
            </div>
          </div>)}
        </div>
        <div style={{ display: "flex", flexWrap: "wrap" }}>
         <div style={{ flex: "1"}}>
          <div style={{display:"flex",flexWrap:"wrap", flexDirection:"column"}}>
            <label style={{ marginRight:"1rem", fontFamily: "Montserrat", fontSize: "1.5rem",color: "rgb(23, 115, 188)"}}>
              Description 
            </label>
            <label style={{  fontFamily: "Montserrat", fontSize: "1.7rem"}}>
              {props.sessionData.description}
            </label>
            </div>
          </div>
        </div>
      </div>

      {openReasonTextbox&&(<div style={{ display: "flex",paddingTop: "2rem",justifyContent: "flex-end",width:'100%'}}>
      <TextField id="outlined-size-small" label="Reason" size="small" variant="outlined" value={reason} onChange={handleReasonChange} fullWidth />
      <Button onClick={handleSubmit} variant="contained"  color="primary" style={{ marginLeft:"1rem",width:"8.6rem",height:"2.5rem",marginTop:"0.2rem"  }}>Submit</Button>
      <Button onClick={handleCancel}  variant="contained" style={{marginLeft:"1rem",backgroundColor:"#cfcfd4",color:"black",width:"8.6rem" ,height:"2.5rem",marginTop:"0.2rem" }}>Cancel</Button>
      </div>)}
      <div
        style={{
          display: "flex",
          paddingTop: "2rem",
          justifyContent: "flex-end",
        }}
      >
       
        
        {!isRegistered&&(props.sessionData.status==="Published")&&moment().isSameOrBefore(moment(props.sessionData.registrationEndDate),'day')&&moment().isSameOrAfter(moment(props.sessionData.registrationStartDate),'day')&&(
          <Button
          onClick={() => {
            dispatch(registerUserSessionData({
              sessionId:props.sessionData.sessionId,
            }))
            setSelectedUsers([]); setSelectedUserIds(""); handleClose();
          }}
          type="submit"
          variant="contained"
          color="primary"
          style={{  width:"17rem" }}
        >
          {(userData.data.roleName==="Admin" || userData.data.roleName==="Project Manager") ? "Register Yourself" : "Register"}
        </Button>)}
        {isRegistered&&(props.sessionData.status==="Published")&&moment().isSameOrAfter(moment(props.sessionData.registrationStartDate),'day')&&(
          <Button
          onClick={() => {
            setOpenReasonTextbox(true);
          }}
          type="submit"
          variant="contained"
          color="primary"
          disabled={openReasonTextbox}
          style={{ width:"17rem" }}
        >
          Revoke Registration
        </Button>)}
        
        {userData.data.roleName === "Employee"&&(
          <Button
          onClick={() => { setSelectedUsers([]); setSelectedUserIds(""); handleClose(); }} variant="contained" style={{backgroundColor:"#cfcfd4",color:"black",width:"17rem",marginLeft:"1rem"  }} >
          Close
          </Button>)}
        
      </div>
      
      {(props.sessionData.status==='Published')&&moment().isSameOrBefore(moment(props.sessionData.registrationEndDate),'day')&&moment().isSameOrAfter(moment(props.sessionData.registrationStartDate),'day')&&(userData.data.roleName === "Admin"||userData.data.roleName === "Project Manager") &&<svg width="100%" height="1" style={{marginTop:"2rem"}}>
      <line x1="0" y1="0" x2="100%" y2="0" stroke="rgb(23, 115, 188)" strokeWidth="1" /></svg>}


      <div style={{display:"flex",justifyContent:"flex-end"}}>
      {(props.sessionData.status==='Published')&&moment().isSameOrBefore(moment(props.sessionData.registrationEndDate),'day')&&moment().isSameOrAfter(moment(props.sessionData.registrationStartDate),'day')&&(userData.data.roleName === "Admin"||userData.data.roleName === "Project Manager")&&(
      <div style={{ display: "flex",paddingTop: "2rem",width:'100%', flexDirection: 'column'}}>
        
        {/* Auto Approve Toggle */}
        <div style={{ marginBottom: "2rem", display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
          <FormControlLabel
            control={
              <Switch
                checked={autoApprove}
                onChange={(e) => setAutoApprove(e.target.checked)}
                color="primary"
              />
            }
            label={
              <Typography style={{ fontSize: "1.5rem", fontWeight: "600", color: "grey", fontFamily: "Montserrat" }}>
                Auto Approve Nominations
              </Typography>
            }
          />
        </div>

        {/* Manual Nomination Section */}
        <div style={{ display: "flex", alignItems: "center", marginBottom: "2rem", flexWrap: "nowrap" }}>
          <span style={{fontSize: "1.5rem",fontWeight: "600",color: "grey",marginRight: "1.5rem",whiteSpace: "nowrap",fontFamily:"Montserrat", flexShrink: 0}}>Select Your Team Members To Nominate For This Training :</span>
          { createTopBarForViewAndNominate()}
        </div>

        {/* Nominate and Close buttons on the same line */}
        <div style={{display:"flex",justifyContent:"flex-end",gap:"1rem"}}>
          <Button
            onClick={() => {
              const nominationData = {
                sessionId: props.sessionData.sessionId,
                employeeIDs: selectedUserIds,
                autoApprove: autoApprove
              };
              console.log("Nomination JSON body:", nominationData);
              dispatch(registerUserSessionData(nominationData));
              setSelectedUserIds("");
              setSelectAll(false);
              setSelectedUsers([]);
            }}
            type="submit"
            variant="contained"
            color="primary"
            disabled={!selectedUserIds.length}
            style={{width:"17rem" }}
          >
            Nominate
          </Button>
          <Button
            onClick={() => { setSelectedUsers([]); setSelectedUserIds(""); handleClose(); }} 
            variant="contained" 
            style={{backgroundColor:"#cfcfd4",color:"black",width:"17rem"}} 
          >
            Close
          </Button>
        </div>
      </div>)}
        </div>

        {/* Bulk Upload Dialog */}
        <Dialog
          open={bulkUploadOpen}
          onClose={closeBulkUpload}
          maxWidth="sm"
          PaperProps={{
            style: {
              padding: "20px",
              borderRadius: "12px",
              width: "500px",
            },
          }}
        >
          <DialogTitle>
            <Typography variant="h4" style={{ fontWeight: "bold", color: "#1773bc", textAlign: "center"}}>
              Bulk Nominate via Excel Upload
            </Typography>
          </DialogTitle>
          
          <DialogContent>
            <Box sx={{ padding: "16px 0" }}>

              {/* File Upload */}
              <Box sx={{ 
                border: '2px dashed #d1d5db',
                borderRadius: '8px',
                padding: '24px',
                textAlign: 'center',
                backgroundColor: '#f9fafb',
                transition: 'all 0.3s ease',
                '&:hover': {
                  borderColor: '#1976d2',
                  backgroundColor: '#f0f8ff'
                },
                marginBottom: "20px"
              }}>
                <input
                  type="file"
                  accept=".xlsx,.xls"
                  onChange={handleFileSelect}
                  style={{ display: 'none' }}
                  id="bulk-upload-file"
                  ref={fileInputRef}
                />
                <label htmlFor="bulk-upload-file" style={{ cursor: 'pointer' }}>
                  <CloudUploadIcon sx={{ fontSize: '48px', color: '#1976d2', marginBottom: '16px' }} />
                  <Typography variant="h6" sx={{ marginBottom: '8px', color: '#374151', fontSize: '1.3rem' }}>
                    {selectedFile ? selectedFile.name : 'Choose Excel File'}
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#6b7280', fontSize: '1.1rem' }}>
                    Click to browse or drag and drop your Excel file (.xlsx, .xls)
                  </Typography>
                </label>
              </Box>

              {/* Auto Approve Toggle for Bulk Upload */}
              <Box sx={{ marginBottom: "20px", display: "flex", justifyContent: "center" }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={autoApprove}
                      onChange={(e) => setAutoApprove(e.target.checked)}
                      color="primary"
                    />
                  }
                  label={
                    <Typography style={{ fontSize: "1.3rem", fontWeight: "500", color: "#374151" }}>
                      Auto Approve Nominations
                    </Typography>
                  }
                />
              </Box>

              {/* Upload Results */}
              {uploadResults && (
                <Box sx={{ marginTop: "20px" }}>
                  <Alert 
                    severity={uploadResults.failedCount > 0 ? "warning" : "success"} 
                    sx={{ marginBottom: "16px" }}
                  >
                    <Typography variant="body1" sx={{ fontSize: "1.2rem", fontWeight: "bold" }}>
                      {uploadResults.message}
                    </Typography>
                    <Typography variant="body2" sx={{ fontSize: "1.1rem", marginTop: "8px" }}>
                      Successfully processed: {uploadResults.successCount} nominees<br />
                      Failed: {uploadResults.failedCount} nominees
                    </Typography>
                  </Alert>

                  {/* Failed Rows Details */}
                  {uploadResults.failedRows && uploadResults.failedRows.length > 0 && (
                    <Box sx={{ marginTop: "16px" }}>
                      <Typography variant="h6" sx={{ fontSize: "1.2rem", fontWeight: "bold", marginBottom: "8px", color: "#d32f2f" }}>
                        Failed Entries:
                      </Typography>
                      {uploadResults.failedRows.map((failedRow, index) => (
                        <Box key={index} sx={{ 
                          backgroundColor: "#fef2f2", 
                          border: "1px solid #fecaca", 
                          borderRadius: "4px", 
                          padding: "8px", 
                          marginBottom: "8px" 
                        }}>
                          <Typography variant="body2" sx={{ fontSize: "1.1rem", color: "#991b1b" }}>
                            <strong>Row {failedRow.rowNumber}:</strong> {failedRow.employeeId} - {failedRow.name}
                          </Typography>
                          <Typography variant="body2" sx={{ fontSize: "1rem", color: "#dc2626", marginTop: "4px" }}>
                            Reason: {failedRow.reason}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                  )}
                </Box>
              )}
            </Box>
          </DialogContent>
          
          <DialogActions sx={{ padding: "16px 24px" }}>
            <Button onClick={closeBulkUpload} variant="outlined">
              Cancel
            </Button>
            <Button 
              onClick={handleBulkUpload} 
              variant="contained" 
              disabled={!selectedFile || isUploading}
              startIcon={isUploading ? null : <CloudUploadIcon />}
            >
              {isUploading ? 'Uploading...' : 'Upload'}
            </Button>
          </DialogActions>
        </Dialog>
    </div>
  );
};
export default ViewAndNominate;